import React from 'react';

import './index.css';


const getText = () => (
  <div styleName="textContainer">
    Unless the offering statement has been qualified, no money or other
    consideration is being solicited, and if sent, will not be accepted.
    No sales will be made or commitments to purchase accepted until the
    offering statement is qualified.  A prospective purchaser&#39;s
    indication of interest in non-binding.
  </div>
);

export default getText;



// WEBPACK FOOTER //
// ./src/components/ExternalInvest/DisclaimerViews/OtherFactorsText.js